import { AuthorizationScope } from '../AuthorizationScope'

const scope: AuthorizationScope = {
  _id: 'WORKSPACE_PROJECT_CARBON_DEDUCTION',
  name: 'Workspace Project Carbon Deduction',
  type: 'PROJECT',
  description: '',
  modules: [],
  fields: [
    { key: 'status', title: 'Status' },
    { key: 'deduction_type', title: 'Deduction type' },
    { key: 'deduction_required_by', title: 'Deduction required by' },
    { key: 'deduction_description', title: 'Deduction description' },
    { key: 'deduction_percentage', title: 'Deduction percentage' },
    { key: 'credit_association', title: 'Credit association' },
    { key: 'credit_issued_at_later_stage', title: 'Credit issued at later stage' },
    { key: 'credit_deduction_percentage', title: 'Credit deduction percentage' },
    { key: 'credit_description', title: 'Credit description' },
    { key: 'createdAt', title: 'Date Created' },
    { key: 'updatedAt', title: 'Date Updated' },
  ],
  actions: ['READ', 'CREATE', 'UPDATE', 'DESTROY'],
}

export default scope
